/* eslint-disable camelcase */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Link } from 'react-router-dom';
import { FormControl, Grid, TextField } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { Controller } from '../../../common/Controller';
import { AppConfig } from '../../../AppConfig';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { SubEntityCard } from '../../../common/components/SubEntity/SubEntityCard';
import { SubEntityList } from '../../../common/components/SubEntity/SubEntityList';
import { StatCard } from '../../../common/components/StatCard';
import { CommonTheme } from '../../../styles/Styles';
import { CdpHelper } from '../../../helpers/CdpHelper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { AppHelper } from '../../../helpers/AppHelper';
import { AppUiHelper } from '../../../helpers/AppUiHelper';
import { LineChartCard } from '../../../common/components/charts/ChartCard';
import { CRMHelper } from '../../../helpers/CRMHelper';

function getCustomFieldDef(fieldDef, crmContactsFieldDef) {
  const _url = new URL(document.location.href)
  const showInternal = (_url.searchParams.has('showinternal') || _url.searchParams.has('showInternal')) && (_url.searchParams.get('showinternal') === 'true' || _url.searchParams.get('showInternal') === 'true')

  const customFieldDef = JSON.parse(JSON.stringify(fieldDef))

  const additionalFields = [
    {
      key: 'title',
      type: 'edit_text',
      label: 'Nickname',
      hint: 'Provide nickname',
      tip: 'Enter a nickname for the template',
      // eslint-disable-next-line camelcase
      v_required: { value: true, err: 'Provide nickname' },
      placement: 'left',
      hidden: true
    },
    {
      key: 'subject',
      type: 'edit_text',
      label: 'Email Subject',
      hint: 'Enter email subject here ...',
      tip: 'Enter the email subject here; Supports template variables contact.name, contact.firstname, contact.middlename, contact.lastname, contact.email, contact.phone, contact.company, sender.name, sender.email; enclose in double braces like {{contact.name}}',
      // eslint-disable-next-line camelcase
      v_required: { value: false },
      placement: 'left'
    },
    {
      key: 'bodyRichText',
      type: 'rich_text',
      label: 'Email Body',
      hint: 'Enter email body here ...',
      tip: 'Enter the email body here; Supports template variables contact.name, contact.firstname, contact.middlename, contact.lastname, contact.email, contact.phone, contact.company, sender.name, sender.email; enclose in double braces like {{contact.name}}',
      // eslint-disable-next-line camelcase
      v_required: { value: true, err: 'Provide email body' },
      placement: 'left',
      variablePicker: {
        title: 'Custom Fields',
        options: AppUiHelper.getEmailTemplateVariables(crmContactsFieldDef)
      }
    },
    {
      key: 'attachment',
      linkName: 'attachmentsLink',
      type: 'document',
      subType: 'document',
      label: 'Attachment',
      tip: 'Select a file to attach to the email',
      // eslint-disable-next-line camelcase
      v_required: { value: false },
      placement: 'right',
      documentUpload: true,
      fileSizeLimit: 10485760,
      uploadAccept: 'application/*, audio/*, image/*, text/*, video/*',
    },
    {
      key: 'shared',
      type: 'radio',
      label: 'Shared',
      options: [{key: 'YES', label: 'YES'}, {key: 'NO', label: 'NO'}],
      // eslint-disable-next-line camelcase
      v_required: {
        value: false,
        err: 'Choose a value'
      },
      placement: 'left',
      defaultValue: 'NO',
      hidden: true
    },
  ]

  let fields = customFieldDef.steps[0].fields
  fields.forEach((field)=>{
    if(field.key !== 'stepIncludeEmailSignature') {
      field.placement = 'right'
    }
    if(field.key === 'stepAction') {
      field.hidden = true
    }
  })
  fields = [...additionalFields, fields[2], fields[0], fields[1],...fields.slice(3)]
  fields = fields.filter(item => item.key !== 'stepEmailTemplateId');
  customFieldDef.steps[0].fields = fields

  if(!showInternal && customFieldDef &&  customFieldDef.steps && customFieldDef.steps.length > 0 && customFieldDef.steps[0].fields) {
    customFieldDef.steps[0].fields = customFieldDef.steps[0].fields.filter(field => field.key !== 'stepTimeDelayMs')
  }
  return customFieldDef
}

function getCampaignFields(obj) {
  const transformField = (field, iType) => {
    const outField = JSON.parse(JSON.stringify(field))
    if (field.condition && ((field.condition.value && field.condition.value === iType) || (field.condition.values && field.condition.values.includes(iType)))) {
      delete outField.condition
    }
    return outField
  }
  return {
    DRIP: obj.fieldDefCampaignDrip.steps[0].fields.map(f => transformField(f, 'DRIP')),
  }[obj.campaignType] || []
}

function countUnique(enrolments, key) {
  const numUnique = enrolments.reduce((p, c) => p + ((c[key] || 0) > 0 ? 1 : 0), 0)
  return numUnique
}

function getUniquePercent(value, total) {
  let numUniquePercent = Math.round((value / total) * 100)
  numUniquePercent = isNaN(numUniquePercent) ? '0%' : `${numUniquePercent}%`
  return numUniquePercent
}

export class SequenceDetail extends BaseEntityPageSlixta {
  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = 'Sequence Detail'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.staffUserId = Controller.get().getUserId()
    this.attribsGroupId = 'settingscrmcontactattrs' + this.orgId
    this.campaignId = this.props.match.params.id
    this.breadCrumbs = [
      { title: Helper.getString('backToSequences'), to: this.baseRoute() + '/campaigns/sequences', type: 'button', icon: 'arrow_back_ios' },
    ]
    this.toFetch = [
      { key: 'campaign', ms: this.ms, method: 'GET', paths: ['campaigns', this.campaignId], queryParams: { orgId: this.orgId, pb: 'fieldDefCampaignDrip, fieldDefCampaignDripSteps' } },
      { key: 'templates', ms: this.ms, method: 'GET', paths: ['crmemailtemplates'], queryParams: { orgId: this.orgId, includeShared: 'true', limit: 200 } },
      { key: 'crminboxes', ms: this.ms, method: 'GET', paths: ['crminboxs'], queryParams: { orgId: this.orgId, orgIdUserId: `${this.orgId}-${this.staffUserId}`, includeShared: 'true' } },
      { key: 'contactenrolments', ms: this.ms, method: 'GET', paths: ['miscs', 'get-enrolled-contacts'], queryParams: { orgId: this.orgId, campaignId: this.campaignId, includeEnrolments: 'true' } },
      { key: 'crmcontactattrs', ms: this.ms, method: 'GET', paths: ['items', `${this.attribsGroupId}-all`], queryParams: { orgId: this.orgId, groupId: this.attribsGroupId } },
      { key: 'crmContacts', ms: this.ms, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, pb: 'fieldDef', includeCustomFields: 'true', limit: 1 } },
    ]
    this.cellWidths = {
      Step: Styles.cellWidthSmall,
      Content: Styles.cellWidthWide,
      Delay: Styles.cellWidthNormal,
    }
    this.apiData = {
      orgId: this.orgId
    }
    this.pageKey = this.pageTitle
    this.uploadLocation = `${this.orgId}/__FILENAME__`
    this.uploadMs = AppConfig.CDP_MS.ENDPOINT
    this.noAdd = true
    this.entityAttrName = 'steps'
    this.stepsTableHeadersMap = {
      Step: (current) => current.__index + 1,
      Content: (current) => {
        let firstStepEmailTemplate
        if(this.emailTemplates && this.emailTemplates.length > 0 && this.steps && this.steps.length > 0) {
          firstStepEmailTemplate = this.emailTemplates.find(t => t.id === this.steps[0].stepEmailTemplateId)
        }

        const emailTemplate = this.emailTemplates.find(t => t.id === current.stepEmailTemplateId)
        let subject = emailTemplate && emailTemplate.subject
        if(this.campaign && this.campaign.threadEmailsAsReplies === 'ENABLED' && firstStepEmailTemplate && firstStepEmailTemplate.subject && current.__index !== 0) {
          subject = `RE: ${firstStepEmailTemplate.subject}`
        }

        return <div className={css(Styles.stepContent)}>
          {subject && <span className={css(Styles.line2)}>{`Sub: ${subject}`}</span>}
          {emailTemplate && emailTemplate.bodyRichText && <span className={css(Styles.line2)} dangerouslySetInnerHTML={{ __html: Helper.renderHtmlText(emailTemplate.bodyRichText) }}></span>}
          {current && current.stepIncludeEmailSignature === 'ENABLED' && <span className={css(Styles.line2)}>{'Signature: YES'}</span>}
          {emailTemplate && emailTemplate.attachment && <span className={css(Styles.line2)}>{'Attachment: YES'}</span>}
        </div>
      },
      Delay: (current) => {
        return <div>
          {current.stepTimeDelayDays && <span className={css(Styles.line1)}>{current.stepTimeDelayDays} days</span>}
          {current.stepTimeDelayDays && current.stepTimeDelayMs && <br />}
          {current.stepTimeDelayMs && <span className={css(Styles.line1)}>{current.stepTimeDelayMs} ms</span>}
        </div>
      },
    }

    this.enrolmentstableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        const crmContact = this.crmContacts.find(c => c.userId === current.userId)
        const crmInbox = this.crmInboxes.find(i => i.id === current.inboxId)
        const steps = crmContact && crmContact.enrolmentSlots && crmContact.enrolmentSlots.steps ? Object.values(crmContact.enrolmentSlots.steps) : []
        let infoText = ''
        if (current.state === 'COMPLETED' && Array.isArray(current.stepsExecuted) && current.stepsExecuted.length > 0) {
          infoText = 'Completed on: ' + Helper.formatTimestamp(Math.max(...current.stepsExecuted.map(s => s.createdTs)))
        } else if (['ERROR', 'PAUSED'].includes(current.state)  && Array.isArray(current.stepsExecuted) && current.stepsExecuted.length > 0) {
          infoText = 'Last email sent on: ' + Helper.formatTimestamp(Math.max(...current.stepsExecuted.map(s => s.createdTs)))
        }
        if (!infoText && steps.length > 0) {
          const startDate = Math.min(...steps)
          const endDate = Math.max(...steps)
          if (Array.isArray(current.stepsExecuted) && current.stepsExecuted.length > 0) {
            infoText = 'Complete by: ' + Helper.formatTimestamp(Helper.getNextHourTs(endDate))
          } else if (current.cstate === 'LIVE' && current.state === 'LIVE') {
            infoText = 'Start by: ' + Helper.formatTimestamp(Helper.getNextHourTs(startDate))
          }
        }
        if (!infoText) {
          infoText = 'Created: ' + Helper.formatTimestamp(current.createdTs)
        }
        infoText = infoText + ` | Sending inbox: ${crmInbox ? crmInbox.email : current.inboxId}`
        return <div>
          {crmContact && <span className={css(Styles.line1)}>{`${Helper.formatName(crmContact)} <${crmContact.email}>`}</span>}
          {crmContact && <br/>}
          <span className={css(Styles.line2)}>{infoText}</span>
        </div>
      },
      Status: (current) => {
        const emailClickTrail = UiHelper.renderEmailClickTrail(current.emailClickTrail || [])
        const enrolmentSource = CdpHelper.getEnrolmentSource(current)
        const enrolmentSourcePath = CdpHelper.getEnrolmentSourcePath(current, this.baseRoute())
        const completionReason = current.completionReason && current.completionReason.trim()
          ? current.completionReason.replace(/^RULE_STEP0_/, '')
          : ''
        return <div>
          <span className={css(Styles.line1)}>{current.state}</span>
          {current.state === 'COMPLETED' && completionReason && <span className={css(Styles.line2)}>&nbsp;[{completionReason}]</span>}
          <br/>
          {CdpHelper.isNewDripExecuteStats(this.campaign) && <>
            <span className={css(Styles.line2)}>Source: {enrolmentSourcePath
              ? <Link to={enrolmentSourcePath}>{enrolmentSource}</Link>
              : enrolmentSource}</span>
            <br/>
          </>}
          <span className={css(Styles.line2)}>Sent: {(current.stepsExecuted || []).length}</span>
          <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>
          {this.campaign && this.campaign.doOpenTracking === 'ENABLED' && <span className={css(Styles.line2)}>Open: {current.emailOpenCount || 0}</span>}
          {this.campaign && this.campaign.doOpenTracking === 'ENABLED' && <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>}
          {this.campaign && this.campaign.doClickTracking === 'ENABLED' && <span title={emailClickTrail} className={css(Styles.line2)}>Click: {current.emailClickCount || 0}</span>}
          {this.campaign && this.campaign.doClickTracking === 'ENABLED' && <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>}
          <span className={css(Styles.line2)}>Reply: {current.emailReplyCount || 0}</span>
          <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>
          <span className={css(Styles.line2)}>Bounce: {current.emailBounceCount || 0}</span>
          {this.campaign && this.campaign.doOpenTracking === 'ENABLED' && current.emailOpenCountUpdateTs > 0 && <><br/><span className={css(Styles.line2)}>Last opened on {Helper.formatTimestamp(current.emailOpenCountUpdateTs)}</span></>}
        </div>
      },
    }

    this.enrollmentFilter = 'all'
    this.enrollmentFilters = [
      {
        key: 'all',
        label: 'All'
      },
      {
        key: 'replied',
        label: 'Replied'
      },
      {
        key: 'bounced',
        label: 'Bounced'
      },
    ]
  }

  async onFetchSuccess(results) {
    this.campaign = this.getResult(results, 'campaign')
    CdpHelper.patchDripCampaignTracking(this.campaign)
    this.steps = Object.values(this.campaign.steps || {}).sort((a, b) => a.entityCreatedTs - b.entityCreatedTs)
    this.emailTemplates = this.getResult(results, 'templates').items
    this.campaignType = this.campaign.iType
    this.crmContactAttrs = this.getResult(results, 'crmcontactattrs')
    this.sharedCrmInboxes = CRMHelper.filterInboxes(this.getResult(results, 'crminboxes').items, 'trigger')
    const contactEnrolmentsResult = this.getResult(results, 'contactenrolments') || {}
    this.enrolments = contactEnrolmentsResult.enrolments || []
    this.crmContacts = contactEnrolmentsResult.contacts || []
    this.enrolmentsNextPage = contactEnrolmentsResult.nextPage || null
    this.crmInboxes = this.getResult(results, 'crminboxes').items
    const crmContactsResult = this.getResult(results, 'crmContacts')
    this.crmContactsFieldDef = crmContactsResult && crmContactsResult.fieldDef ? crmContactsResult.fieldDef : null
    this.fieldDef = this.formDefinition = getCustomFieldDef(this.campaign.fieldDefCampaignDripSteps, this.crmContactsFieldDef);
    UiHelper.populateOptions(this.fieldDef, {items: this.emailTemplates}, 'stepEmailTemplateId')

    this.fieldDefCampaignDrip = this.campaign.fieldDefCampaignDrip
    if (this.campaignType === 'DRIP') this.fieldDef = this.fieldDefCampaignDrip

    this.pageTitle = this.campaign.title
    const showTenantNameInHeader = AppHelper.isSettingEnabled(this.orgId, 'TENANT_NAME_IN_HEADER')
    if (showTenantNameInHeader) {
      let orgTitle = UiHelper.getOrgTitle()
      if (orgTitle) orgTitle = orgTitle + ' | '
      this.pageTitle = orgTitle + this.pageTitle
    }
    this.headerActions = [
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
    if (this.campaign.state !== 'DELETED') {
      if (['DRAFT', 'PAUSED'].includes(this.campaign.state)) {
        this.headerActions.unshift({
          label: this.campaign.state === 'PAUSED' ? 'Resume' : 'Start',
          tooltip: this.campaign.state === 'PAUSED' ? 'Resume' : 'Start',
          icon: 'send',
          onClick: () => this.updateCampaignState(this.campaign, this.campaign.state === 'PAUSED' ? 'resume' : 'start')
        })
      }
      if (['LIVE'].includes(this.campaign.state)) {
        this.headerActions.unshift({
          label: 'Pause',
          tooltip: 'Pause',
          icon: 'pause',
          onClick: () => this.updateCampaignState(this.campaign, 'pause')
        })
      }
    }

    const additionalFilters = []
    if(this.campaign) {
      if(this.campaign.doOpenTracking === 'ENABLED') {
        additionalFilters.push({
          key: 'opened',
          label: 'Opened'
        })
      }
      if(this.campaign.doClickTracking === 'ENABLED') {
        additionalFilters.push({
          key: 'clicked',
          label: 'Clicked'
        })
      }
    }

    const customEnrollmentFilters = JSON.parse(JSON.stringify(this.enrollmentFilters))
    if(additionalFilters.length > 0) {
      customEnrollmentFilters.splice(1,0,...additionalFilters)
    }

    const showDripActivityCharts = CdpHelper.isNewDripExecuteStats(this.campaign)
      && AppHelper.isSettingEnabled(this.orgId, 'DRIP_CAMPAIGN_DRILLDOWN_CHARTS')
    const dripActivityCharts = showDripActivityCharts
      ? await CdpHelper.fetchDripActivityCharts({ orgId: this.orgId, campaignId: this.campaignId })
      : { engagementChartData: null }

    this.setState({
      enrollments: this.enrolments.sort((a, b) => b.enrolmentStartTs - a.enrolmentStartTs),
      enrollmentFilters: customEnrollmentFilters,
      enrollmentFilter: this.enrollmentFilter,
      enrollmentFilterSelected: customEnrollmentFilters.find(option => option.key === this.enrollmentFilter),
      enrolmentsNextPage: this.enrolmentsNextPage,
      engagementChartData: dripActivityCharts.engagementChartData,
      showDripActivityCharts,
    })
  }

  renderStats() {
    const useExecuteStats = CdpHelper.isNewDripExecuteStats(this.campaign)
    const executeStats = (this.campaign && this.campaign.executeStats) || {}
    const numEnrolments = useExecuteStats
      ? (executeStats.subscribedCount || 0)
      : this.enrolments.length
    const numLiveEnrolments = this.enrolments.reduce((p, c) => p + (c.state === 'LIVE' ? 1 : 0), 0)
    const numAllStepsDone = useExecuteStats
      ? (executeStats.allStepsDoneCount || 0)
      : this.enrolments.reduce((p, c) => p + (c.state === 'COMPLETED' && ['ALL_STEPS_DONE', 'SUCCESS'].includes(c.completionReason) ? 1 : 0), 0)
    const numUnenrols = useExecuteStats
      ? (executeStats.unenrolCount || 0)
      : this.enrolments.reduce((p, c) => p + (c.state === 'COMPLETED' && c.completionReason && c.completionReason.includes('UNENROL') ? 1 : 0), 0)
    const numUniqueSent = useExecuteStats
      ? (executeStats.attemptedCount || 0)
      : this.enrolments.reduce((p, c) => {
        const emailSteps = (c.stepsExecuted || []).filter(s => s.action === 'SEND_EMAIL')
        return p + (emailSteps.length > 0 ? 1 : 0)
      }, 0)
    const numUniqueOpened = useExecuteStats ? (executeStats.openCount || 0) : countUnique(this.enrolments, 'emailOpenCount')
    const numUniqueOpenedPercent = getUniquePercent(numUniqueOpened, numUniqueSent)
    const numUniqueClicked = useExecuteStats ? (executeStats.clickCount || 0) : countUnique(this.enrolments, 'emailClickCount')
    const numUniqueClickedPercent = getUniquePercent(numUniqueClicked, numUniqueSent)
    const numUniqueReplied = useExecuteStats ? (executeStats.replyCount || 0) : countUnique(this.enrolments, 'emailReplyCount')
    const numUniqueRepliedPercent = getUniquePercent(numUniqueReplied, numUniqueSent)
    const numUniqueBounced = useExecuteStats ? (executeStats.bounceCount || 0) : countUnique(this.enrolments, 'emailBounceCount')
    const numUniqueBouncedPercent = getUniquePercent(numUniqueBounced, numUniqueSent)

    let campaignStartDate = Helper.currentTs(), campaignEndDate = -1, isExceedingEndDate = false
    this.crmContacts.forEach(crmContact => {
      const steps = crmContact && crmContact.enrolmentSlots && crmContact.enrolmentSlots.steps ? Object.values(crmContact.enrolmentSlots.steps) : []
      if (steps.length > 0) {
        const startDate = Math.min(...steps)
        const endDate = Math.max(...steps)
        campaignStartDate = Math.min(campaignStartDate, startDate)
        campaignEndDate = Math.max(campaignEndDate, endDate)
        isExceedingEndDate = isExceedingEndDate || steps.includes(-1)
      }
    })

    const uniqueRepliedStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueReplied'}
      text={numUniqueReplied}
      subText={'Unique Replied'}
      cardIndex={1}
      padding='small'
    />
    const uniqueRepliedPercentStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueRepliedPercent'}
      text={numUniqueRepliedPercent}
      subText={'Reply Rate'}
      cardIndex={2}
      padding='small'
    />
    const uniqueBouncedStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueBounced'}
      text={numUniqueBounced}
      subText={'Unique Bounced'}
      cardIndex={3}
      padding='small'
    />
    const uniqueBouncedPercentStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueBouncedPercent'}
      text={numUniqueBouncedPercent}
      subText={'Bounce Rate'}
      cardIndex={4}
      padding='small'
    />
    const uniqueOpenedStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueOpened'}
      text={numUniqueOpened}
      subText={'Unique Opened'}
      cardIndex={5}
      padding='small'
    />
    const uniqueOpenedPercentStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueOpenedPercent'}
      text={numUniqueOpenedPercent}
      subText={'Open Rate'}
      cardIndex={6}
      padding='small'
    />
    const uniqueClickedStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueClicked'}
      text={numUniqueClicked}
      subText={'Unique Clicked'}
      cardIndex={7}
      padding='small'
    />
    const uniqueClickedPercentStatCard = <StatCard
      className={css(Styles.numericStatItem)}
      xs={12}
      sm={3}
      key={'uniqueClickedPercent'}
      text={numUniqueClickedPercent}
      subText={'Click Rate'}
      cardIndex={8}
      padding='small'
    />
    let singleTrackingUniqueStatCard, singleTrackingUniquePercentStatCard
    if (this.campaign) {
      singleTrackingUniqueStatCard = (this.campaign.doOpenTracking === 'ENABLED' && this.campaign.doClickTracking !== 'ENABLED') ? uniqueOpenedStatCard : ((this.campaign.doClickTracking === 'ENABLED' && this.campaign.doOpenTracking !== 'ENABLED') ? uniqueClickedStatCard : null)
      singleTrackingUniquePercentStatCard = (this.campaign.doOpenTracking === 'ENABLED' && this.campaign.doClickTracking !== 'ENABLED') ? uniqueOpenedPercentStatCard : ((this.campaign.doClickTracking === 'ENABLED' && this.campaign.doOpenTracking !== 'ENABLED') ? uniqueClickedPercentStatCard : null)
    }

    const engagementChartData = this.state.engagementChartData || CdpHelper.getDripEngagementChartData([])

    return <div className={css(Styles.containerNarrow, Styles.statsContainer)}>
      {this.state.showDripActivityCharts && (
        <div className={css(Styles.activityChartsContainer)}>
          <LineChartCard item={{
            title: 'Activity',
            data: engagementChartData,
            xLabelsDifference: 4,
            showLegend: (engagementChartData.datasets || []).length > 1,
          }} />
        </div>
      )}
      <Grid container className={css(Styles.numericStatContainer)}>
        <StatCard
          className={css(Styles.numericStatItem)}
          xs={12}
          sm={3}
          key={'enrolments'}
          text={numEnrolments}
          subText={'Enrolments'}
          cardIndex={1}
          padding='small'
        />
        <StatCard
          className={css(Styles.numericStatItem)}
          xs={12}
          sm={3}
          key={'uniqueSent'}
          text={numUniqueSent}
          subText={'Unique Sent'}
          cardIndex={1}
          padding='small'
        />
        <StatCard
          className={css(Styles.numericStatItem)}
          xs={12}
          sm={3}
          key={'liveEnrolments'}
          text={numLiveEnrolments}
          subText={'Live'}
          cardIndex={2}
          padding='small'
        />
        <StatCard
          className={css(Styles.numericStatItem)}
          xs={12}
          sm={3}
          key={'allStepsDone'}
          text={numAllStepsDone}
          subText={'All Steps Done'}
          cardIndex={3}
          padding='small'
        />
        <StatCard
          className={css(Styles.numericStatItem)}
          xs={12}
          sm={3}
          key={'numUnenrols'}
          text={numUnenrols}
          subText={'Unenrols'}
          cardIndex={4}
          padding='small'
        />
      </Grid>
      {singleTrackingUniqueStatCard && singleTrackingUniquePercentStatCard && <>
        <Grid container className={css(Styles.numericStatContainer,Styles.numericStatContainerBottom)}>
          {singleTrackingUniqueStatCard}
          {uniqueRepliedStatCard}
          {uniqueBouncedStatCard}
          {singleTrackingUniquePercentStatCard}
          {uniqueRepliedPercentStatCard}
          {uniqueBouncedPercentStatCard}
        </Grid>
      </>}
      {this.campaign && this.campaign.doOpenTracking === 'ENABLED' && this.campaign.doClickTracking === 'ENABLED' && <>
        <Grid container className={css(Styles.numericStatContainer)}>
          {uniqueOpenedStatCard}
          {uniqueClickedStatCard}
          {uniqueRepliedStatCard}
          {uniqueBouncedStatCard}
        </Grid>
        <Grid container className={css(Styles.numericStatContainer,Styles.numericStatContainerBottom)}>
          {uniqueOpenedPercentStatCard}
          {uniqueClickedPercentStatCard}
          {uniqueRepliedPercentStatCard}
          {uniqueBouncedPercentStatCard}
        </Grid>
      </>}
      {this.campaign && this.campaign.doOpenTracking !== 'ENABLED' && this.campaign.doClickTracking !== 'ENABLED' && <Grid container className={css(Styles.numericStatContainer,Styles.numericStatContainerBottom)}>
        {uniqueRepliedStatCard}
        {uniqueRepliedPercentStatCard}
        {uniqueBouncedStatCard}
        {uniqueBouncedPercentStatCard}
      </Grid>}
      {this.campaign.state === 'DRAFT' && <p className={css(Styles.campaignTimeline)}>{'The campaign is currently in DRAFT state.'}</p>}
      {this.campaign.state === 'PAUSED' && <p className={css(Styles.campaignTimeline)}>{'The campaign is currently paused.'}</p>}
      {this.campaign.state === 'COMPLETED' && <p className={css(Styles.campaignTimeline)}>{'The campaign has completed.'}</p>}
      {this.campaign.state === 'DELETED' && <p className={css(Styles.campaignTimeline)}>{'This sequence has been deleted. Live enrolments were stopped; enrolment history is retained.'}</p>}
      {this.campaign.state === 'LIVE' && campaignEndDate !== -1 && <p className={css(Styles.campaignTimeline)}>{`All live enrolments are expected to complete ${isExceedingEndDate ? 'beyond' : 'by'} ${Helper.formatTimestamp(Helper.getNextHourTs(campaignEndDate))}.`}</p>}
    </div>
  }

  onEnrollmentsFilterChange(value) {
    let filteredEnrollments = this.enrolments
    if(value.key === 'opened') {
      filteredEnrollments = filteredEnrollments.filter((enrolment)=> enrolment.emailOpenCount && Number(enrolment.emailOpenCount) > 0 )
    } else if(value.key === 'clicked') {
      filteredEnrollments = filteredEnrollments.filter((enrolment)=> enrolment.emailClickCount && Number(enrolment.emailClickCount) > 0 )
    } else if(value.key === 'replied') {
      filteredEnrollments = filteredEnrollments.filter((enrolment)=> enrolment.emailReplyCount && Number(enrolment.emailReplyCount) > 0 )
    } else if(value.key === 'bounced') {
      filteredEnrollments = filteredEnrollments.filter((enrolment)=> enrolment.emailBounceCount && Number(enrolment.emailBounceCount) > 0 )
    }

    this.setState({
      enrollmentFilterSelected: value,
      enrollmentFilter: value.key,
      enrollments: filteredEnrollments
    })
  }

  async onEnrolmentsNextPage() {
    if (!this.state.enrolmentsNextPage) {
      return
    }
    this.setState({ enrolmentsNextPageState: ApiHelper.State.LOADING })
    try {
      const queryParams = {
        orgId: this.orgId,
        campaignId: this.campaignId,
        includeEnrolments: 'true',
        nextPage: this.state.enrolmentsNextPage,
      }
      const result = await ApiHelper.callAwait({
        ms: this.ms,
        method: 'GET',
        paths: ['miscs', 'get-enrolled-contacts'],
        queryParams,
      }) || {}
      const nextEnrolments = result.enrolments || []
      const nextContacts = result.contacts || []
      this.enrolments = (this.enrolments || []).concat(nextEnrolments)
      const contactByUserId = {}
      ;(this.crmContacts || []).concat(nextContacts).forEach(c => {
        if (c && c.userId) contactByUserId[c.userId] = c
      })
      this.crmContacts = Object.values(contactByUserId)
      this.enrolmentsNextPage = result.nextPage || null
      const filterSelected = this.state.enrollmentFilterSelected
      let enrollments = this.enrolments.sort((a, b) => b.enrolmentStartTs - a.enrolmentStartTs)
      if (filterSelected && filterSelected.key && filterSelected.key !== 'all') {
        this.onEnrollmentsFilterChange(filterSelected)
        this.setState({
          enrolmentsNextPage: this.enrolmentsNextPage,
          enrolmentsNextPageState: ApiHelper.State.READY,
        })
        return
      }
      this.setState({
        enrollments,
        enrolmentsNextPage: this.enrolmentsNextPage,
        enrolmentsNextPageState: ApiHelper.State.READY,
      })
    } catch (err) {
      this.setState({
        enrolmentsNextPageState: ApiHelper.State.ERROR,
        errMsg: Helper.getErrorMsg(err),
      })
    }
  }

  renderEnrolments() {
    return <div className={css(Styles.container)}>
      <div className={css(Styles.enrollmentsTableHeaderContainer)}>
        <div className={css(Styles.headingContent)}>
          <h2 className={css(Styles.stepFormTitle)}>{Helper.getString('enrolments')}</h2>
        </div>
        <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
          <Autocomplete
            value={this.state.enrollmentFilterSelected}
            options={this.state.enrollmentFilters}
            onChange={(e, val) => this.onEnrollmentsFilterChange(val)}
            getOptionLabel={(option) => option.label || option.text}
            getOptionSelected={(option, value) => option.key === value.key}
            disableClearable
            renderInput={params =>
              <TextField
                {...params}
                variant={'standard'}
                className={css(Styles.formControlFilters)}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  readOnly: true,
                  classes: {
                    root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                    input: css(Styles.formInputStyle, Styles.textInput),
                  },
                }} />}
          />
        </FormControl>
      </div>
      <div className={css(Styles.content, Styles.contentForRow)}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12}>
            <SubEntityList
              tableHeadersMap={this.enrolmentstableHeadersMap}
              items={this.state.enrollments}
              subEntityActions={this.enrolmentsSubEntityActions.bind(this)}
              fetchState={this.state.fetchState}
              isChildTable={true}
              nextPage={this.state.enrolmentsNextPage}
              onNext={() => this.onEnrolmentsNextPage()}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  }

  renderAboveTable() {
    const isDeleted = this.campaign && this.campaign.state === 'DELETED'
    return <div className={css(Styles.containerNarrow)}>
      {(this.campaign.state !== 'DRAFT') && <Grid container>
        <Grid item xs={12}>
          {this.renderStats()}
        </Grid>
      </Grid>}
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SubEntityCard
            renderFieldsRowwise={true}
            title={'Sequence Detail'} formDefinition={this.fieldDefCampaignDrip}
            item={this.campaign || {}}
            noEdit={isDeleted}
            openModalForEdit={(current) => this.openModalForEditSequence(current)}
            advancedView={true}
          />
        </Grid>
      </Grid>
      {this.campaign &&
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12}>
            <SubEntityList
              title={'Steps'}
              tableHeadersMap={this.stepsTableHeadersMap}
              items={this.steps}
              subEntityActions={this.stepsSubEntityActions.bind(this)}
              noAdd={isDeleted || this.campaign.state !== 'DRAFT'}
              fetchState={this.state.fetchState}
              cellWidths={this.cellWidths}
              openModalForAdd={this.openModalForAdd.bind(this)}
            />
          </Grid>
        </Grid>}
      {(this.campaign.state !== 'DRAFT') && <Grid container>
        <Grid item xs={12}>
          {this.renderEnrolments()}
        </Grid>
      </Grid>}
    </div>
  }

  stepsSubEntityActions = (current) => {
    const actions = []
    if (this.campaign && this.campaign.state === 'DELETED') {
      return actions
    }
    actions.push(<Tooltip title={'Edit section'} placement='top-start' key={current.id + 'editTT'}>
      <span className={css(AppStyles.entityTableLinkIcon)}>
        <i className='material-icons-outlined' onClick={() => this.openModalForEditStep(current)}>edit</i>
      </span>
    </Tooltip>)
    actions.push(<Tooltip title={'Send Test Email'} placement='top-start' key={current.id + 'sendTestEmailTT'}>
      <span className={css(AppStyles.entityTableLinkIcon)}>
        <i className='material-icons-outlined' onClick={() => this.openModalForSendTestEmail(current)}>email</i>
      </span>
    </Tooltip>)
    if (this.campaign.state === 'DRAFT') actions.push(<Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
      <span className={css(AppStyles.entityTableLinkIcon)}>
        <i className='material-icons-outlined' onClick={() => this.openModalForDeleteStep(current)}>delete</i>
      </span>
    </Tooltip>)
    return actions
  }

  async updateEnrolmentState(current, newState) {
    this.apiData = {
      orgId: this.orgId,
    }
    const fields = [{
      key: 'state',
      label: 'New enrolment state',
      type: 'edit_text',
      // eslint-disable-next-line camelcase
      v_required: { value: true, err: 'Provide new state' },
      placement: 'left',
      value: newState,
      defaultValue: newState,
      disabled: true,
    }]
    const currentCp = JSON.parse(JSON.stringify(current))
    currentCp.state = newState
    if (newState === 'COMPLETED') {
      this.apiData.completionReason = 'STOPPED'
      currentCp.completionReason = 'STOPPED'
    }
    this.openModalForEditEnrolment(currentCp, {steps: [{ fields }]});
  }

  enrolmentsSubEntityActions = (current) => {
    const actions = []
    const campaignDeleted = this.campaign && this.campaign.state === 'DELETED'

    function addStopAction() {
      actions.push(
        <Tooltip title={'Stop'} placement='top-start' key={current.id + 'stop'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={() => this.updateEnrolmentState(current, 'COMPLETED')}>stop</i>
          </span>
        </Tooltip>
      )
    }
    if (!campaignDeleted) {
      if (current.state === 'LIVE') {
        actions.push(
          <Tooltip title={'Pause'} placement='top-start' key={current.id + 'pause'}>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined' onClick={() => this.updateEnrolmentState(current, 'PAUSED')}>pause</i>
            </span>
          </Tooltip>
        )
        addStopAction.bind(this)()
      } else if (current.state === 'PAUSED') {
        actions.push(
          <Tooltip title={'Resume'} placement='top-start' key={current.id + 'resume'}>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined' onClick={() => this.updateEnrolmentState(current, 'LIVE')}>send</i>
            </span>
          </Tooltip>
        )
        addStopAction.bind(this)()
      } else if (current.state === 'COMPLETED' && ['ERROR', 'TIMEOUT', 'WAIT_TIMEOUT', 'UNENROL_ON_REPLY'].includes(current.completionReason)) {
        actions.push(
          <Tooltip title={'Reset'} placement='top-start' key={current.id + 'reset'}>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined' onClick={() => this.updateEnrolmentState(current, 'LIVE')}>restart_alt</i>
            </span>
          </Tooltip>
        )
      }
    }

    actions.push(
      <Link to={this.baseRoute() + '/crm-contacts/' + current.userId} key={current.userId}>
        <Tooltip title='View Contact' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>person</i>
          </span>
        </Tooltip>
      </Link>
    )

    return actions
  }

  openModalForEditSequence(current) {
    const fields = getCampaignFields(this)
    fields.find(f => f.key === 'title')
    const disableAlwaysFormFields = current.state === 'DRAFT' ? [] : ['channel', 'templateId', 'transactionalEvent', 'notificationEvent', 'segmentId']
    this.formDefinition = {steps: [{ fields }], disableAlwaysFormFields}
    this.formDefinition.formType = 'edit'
    this.formDefinition.title = 'Sequence Detail'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    const triggerInboxField = this.formDefinition.steps[0].fields.find(f => f.key === 'triggerInboxId')
    if (triggerInboxField) {
      triggerInboxField.options = CRMHelper.toInboxSelectOptions(this.sharedCrmInboxes)
    }
    const dripTagOptions = {items: Helper.extractAttrs(this.crmContactAttrs, 'tags').map(t => ({id: t, title: t}))}
    UiHelper.populateOptions(this.formDefinition, dripTagOptions, 'triggerOnTags')
    UiHelper.populateOptions(this.formDefinition, dripTagOptions, 'stopOnTags')
    this.setState({
      apiMethod: 'PUT',
      apiData: {orgId: this.orgId},
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', current.id], queryParams: {orgId: this.orgId} }),
    });
    this.setState({
      modalOpen: true
    });
  }

  openModalForAdd() {
    let firstStepEmailTemplate
    if(this.emailTemplates && this.emailTemplates.length > 0 && this.steps && this.steps.length > 0) {
      firstStepEmailTemplate = this.emailTemplates.find(t => t.id === this.steps[0].stepEmailTemplateId)
    }

    const fieldDef = JSON.parse(JSON.stringify(getCustomFieldDef(this.campaign.fieldDefCampaignDripSteps, this.crmContactsFieldDef)))
    const titleField = Helper.getField(fieldDef, 'title')
    titleField.defaultValue = 'Step - ' + ((this.steps && Array.isArray(this.steps)) ? this.steps.length + 1 : 1)
    const subjectField = Helper.getField(fieldDef, 'subject')
    if(this.campaign && this.campaign.threadEmailsAsReplies === 'ENABLED' && firstStepEmailTemplate && firstStepEmailTemplate.subject && subjectField) {
      subjectField.defaultValue = `RE: ${firstStepEmailTemplate.subject}`
      fieldDef.disableAlwaysFormFields = fieldDef.disableAlwaysFormFields ? fieldDef.disableAlwaysFormFields.push('subject') : ['subject']
    }
    super.openModalForAdd(fieldDef)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiData: { orgId: this.orgId, campaignId: this.campaignId, entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['miscs', 'update-seq-step'], queryParams: {orgId: this.orgId} }),
    });
  }

  openModalForEditStep(current) {
    let firstStepEmailTemplate
    if(this.emailTemplates && this.emailTemplates.length > 0 && this.steps && this.steps.length > 0) {
      firstStepEmailTemplate = this.emailTemplates.find(t => t.id === this.steps[0].stepEmailTemplateId)
    }
    const emailTemplate = this.emailTemplates.find(t => t.id === current.stepEmailTemplateId)
    const modifiedCurrent = {
      ...current,
      title: emailTemplate && emailTemplate.title,
      subject: emailTemplate && emailTemplate.subject,
      bodyRichText: emailTemplate && emailTemplate.bodyRichText,
      attachment: emailTemplate && emailTemplate.attachment,
      attachmentLink: emailTemplate && emailTemplate.attachmentLink,
      attachmentsLink: emailTemplate && emailTemplate.attachmentsLink,
      shared: emailTemplate && emailTemplate.shared
    }
    const fieldDef = JSON.parse(JSON.stringify(getCustomFieldDef(this.campaign.fieldDefCampaignDripSteps, this.crmContactsFieldDef)))
    if(this.campaign && this.campaign.threadEmailsAsReplies === 'ENABLED' && firstStepEmailTemplate && firstStepEmailTemplate.subject && current.__index !== 0) {
      modifiedCurrent.subject = `RE: ${firstStepEmailTemplate.subject}`
      fieldDef.disableAlwaysFormFields = fieldDef.disableAlwaysFormFields ? fieldDef.disableAlwaysFormFields.push('subject') : ['subject']
    }
    super.openModalForEdit(modifiedCurrent, fieldDef)
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'POST',
      apiData: { orgId: this.orgId, campaignId: this.campaignId, entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id, stepEmailTemplateId: current.stepEmailTemplateId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['miscs', 'update-seq-step'], queryParams: {orgId: this.orgId} }),
    });
  }

  openModalForEditEnrolment(current, fieldDef) {
    this.formDefinition = fieldDef || this.fieldDef || this.formDefinition
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEditEnrolment(current);
    this.setState({
      modalOpen: true
    });
  }

  onEditEnrolment(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['seqenrolments', current.id], queryParams: {orgId: this.orgId} }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'POST',
      apiData: { orgId: this.orgId, campaignId: this.campaignId, entityAction: 'del', entityAttrName: this.entityAttrName, id: current.id, stepEmailTemplateId: current.stepEmailTemplateId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['miscs', 'update-seq-step'], queryParams: {orgId: this.orgId} }),
    });
  }

  openModalForDeleteStep(current) {
    let firstStepEmailTemplate
    if(this.emailTemplates && this.emailTemplates.length > 0 && this.steps && this.steps.length > 0) {
      firstStepEmailTemplate = this.emailTemplates.find(t => t.id === this.steps[0].stepEmailTemplateId)
    }

    const emailTemplate = this.emailTemplates.find(t => t.id === current.stepEmailTemplateId)
    const modifiedCurrent = {
      ...current,
      title: emailTemplate && emailTemplate.title,
      subject: emailTemplate && emailTemplate.subject,
      bodyRichText: emailTemplate && emailTemplate.bodyRichText,
      attachment: emailTemplate && emailTemplate.attachment,
      attachmentLink: emailTemplate && emailTemplate.attachmentLink,
      attachmentsLink: emailTemplate && emailTemplate.attachmentsLink,
      shared: emailTemplate && emailTemplate.shared
    }
    const fieldDef = JSON.parse(JSON.stringify(getCustomFieldDef(this.campaign.fieldDefCampaignDripSteps, this.crmContactsFieldDef)))
    if(this.campaign && this.campaign.threadEmailsAsReplies === 'ENABLED' && firstStepEmailTemplate && firstStepEmailTemplate.subject && current.__index !== 0) {
      modifiedCurrent.subject = `RE: ${firstStepEmailTemplate.subject}`
    }
    super.openModalForDelete(modifiedCurrent, fieldDef)
  }

  openModalForSendTestEmail(current) {
    // Get email template data
    const emailTemplate = this.emailTemplates.find(t => t.id === current.stepEmailTemplateId)
    const subject = current.emailSubject || (emailTemplate && emailTemplate.subject) || 'Test Email'

    const fieldDef = {
      steps: [{
        fields: [
          {
            key: '_subject',
            type: 'edit_text',
            label: 'Email Subject',
            hint: 'Email subject',
            tip: 'This is the subject that will be sent in the test email',
            v_required: { value: false },
            placement: 'left',
            defaultValue: subject,
          },
          {
            key: '_bodyRichText',
            type: 'rich_text',
            label: 'Email Body',
            hint: 'Email body',
            tip: 'This is the body that will be sent in the test email',
            v_required: { value: false },
            placement: 'left',
            value: emailTemplate && emailTemplate.bodyRichText || '',
          },
          {
            key: 'recipients',
            type: 'edit_text',
            label: 'Recipients',
            hint: 'Enter email addresses separated by commas',
            tip: 'Enter one or more email addresses separated by commas (e.g., john@example.com, jane@example.com)',
            v_required: { value: true, err: 'Provide at least one recipient email' },
            placement: 'left'
          },
          {
            key: 'inboxId',
            type: 'radio',
            label: 'Inbox',
            hint: 'Select inbox',
            tip: 'Select the inbox to send the test email from',
            v_required: { value: true, err: 'Select an inbox' },
            placement: 'left',
            options: CRMHelper.toInboxSelectOptions(
              CRMHelper.filterInboxes(this.crmInboxes, 'sendOrEnrol')
            )
          },
          {
            key: 'friendlyname',
            type: 'edit_text',
            label: 'Friendly Name (Optional)',
            hint: 'Enter friendly name',
            tip: 'Optional friendly name to use in the email template',
            v_required: { value: false },
            placement: 'left'
          },
          {
            key: 'friendlycompanyname',
            type: 'edit_text',
            label: 'Friendly Company Name (Optional)',
            hint: 'Enter friendly company name',
            tip: 'Optional friendly company name to use in the email template',
            v_required: { value: false },
            placement: 'left'
          },
          {
            key: 'customText',
            type: 'edit_text',
            label: 'Custom Text (Optional)',
            hint: 'Enter custom text',
            tip: 'Optional custom text to insert into the message',
            v_required: { value: false },
            placement: 'left'
          }
        ]
      }],
      formType: 'add',
      title: 'Send Test Email',
      ctaButtonText: 'Send',
      disableAlwaysFormFields: ['_subject', '_bodyRichText']
    }

    this.formDefinition = fieldDef
    this.setState({
      apiMethod: 'POST',
      apiData: {
        orgId: this.orgId,
        campaignId: this.campaignId,
        stepId: current.id
      },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['miscs', 'send-test-email'], queryParams: {orgId: this.orgId} }),
    })
    this.setState({
      modalOpen: true
    })
  }

  openModalForSequenceUpdateAction(current, action, fieldDef) {
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'edit'
    this.formDefinition.title = 'Edit Sequence State'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiMethod: 'PUT',
      apiData: { updateAction: action, orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', current.id], queryParams: {orgId: this.orgId} }),
      modalOpen: true
    });
  }

  async updateCampaignState(current, action) {
    const fields = [{
      key: 'updateAction',
      label: 'Update action',
      type: 'edit_text',
      hint: 'Update action',
      // eslint-disable-next-line camelcase
      v_required: { value: true, err: 'Provide update action' },
      placement: 'left',
      value: action,
      disabled: true,
    }]
    current.updateAction = action
    this.openModalForSequenceUpdateAction(current, action, {steps: [{ fields }]});
  }
}

const Styles = StyleSheet.create({
  container: {
    background: 'white',
    border: CommonTheme.containerBorderColor,
    height: '100%',
    borderRadius: 16,
  },
  content: {
    padding: '0px 30px',
    marginBottom: -3,
    '@media (max-width: 767px)': {
      padding: '0px 15px',
    }
  },
  contentForRow: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  headingContent: {
    padding: '18px 5px 18px 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media (max-width: 767px)': {
      padding: '18px 5px 18px 15px',
    }
  },
  stepFormTitle: {
    color: CommonTheme.textColor,
    fontSize: 20,
    fontWeight: 600,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    marginRight: 10
  },
  line1: {
    fontSize: 16
  },
  line2: {
    fontSize: 12,
    color: 'gray'
  },
  line3: {
    fontSize: 12,
    color: '#AAAAAA'
  },
  spanValue: {
    fontSize: 12
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 50,
    width: '100%',
  },
  statsContainer: {
    paddingBottom: 0,
    gap: 0
  },
  activityChartsContainer: {
    width: '100%',
    maxWidth: AppTheme.viewPort,
    marginBottom: 16,
  },
  numericStatContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    justifyContent: 'space-between',
    marginBottom: 16,
    gap: '16px',
  },
  campaignTimeline: {
    textAlign: 'center',
    fontSize: 16,
    color: 'gray'
  },
  numericStatContainerBottom: {
    marginBottom: 0,
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 4
  },
  cellWidthSmall: {
    width: '10%',
  },
  cellWidthNormal: {
    width: '20%',
  },
  cellWidthWide: {
    width: '50%',
  },
  enrollmentsTableHeaderContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  formControlMainFilters: {
    width: 150,
    padding: '5px 30px 5px 5px',
    '@media (max-width: 1024px)': {
      width: '40vw',
      alignSelf: 'center',
      paddingRight: '10px',
    },
  },
  formControlFilters: {
    width: 120,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  autoCompleteInputRoot: {
    paddingTop: 5,
    paddingBottom: 5
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  textInput: {
    padding: '2px 0px',
    '@media (max-width: 440px)': {
      fontSize: 12,
    },
  },
})